import { useEffect } from 'react';
import { HashRouter } from 'react-router-dom';
import { AdminShell } from '@/components/layout/AdminShell';
import { ConnectScreen } from '@/components/layout/ConnectScreen';
import { Toaster } from '@/components/feedback/Toaster';
import { LoadingState } from '@/components/feedback/StateViews';
import { useSessionStore } from '@/store/useSessionStore';
import { useMerchantStore } from '@/store/useMerchantStore';
import { AppRouter } from '@/router/AppRouter';

/**
 * Root component. Resolves the merchant + dashboard token (from the host URL or
 * env), gates the dashboard behind a Connect screen until both are present, and
 * renders the routed admin UI inside the shell.
 */
export function App() {
  const bootstrap = useSessionStore((state) => state.bootstrap);
  const isReady = useSessionStore((state) => state.isReady);
  const isConnected = useSessionStore((state) => state.isConnected());
  const isLoggingOut = useSessionStore((state) => state.isLoggingOut);
  const loadProfile = useMerchantStore((state) => state.loadProfile);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  useEffect(() => {
    // Wait for the session handshake so the profile call carries the fresh
    // session info, not the stale rehydrated one.
    if (isReady && isConnected) {
      loadProfile();
    }
  }, [isReady, isConnected, loadProfile]);

  return (
    <>
      {!isReady || isLoggingOut ? (
        <div className="flex min-h-screen items-center justify-center">
          <LoadingState message={isLoggingOut ? 'Logging out…' : 'Connecting…'} />
        </div>
      ) : isConnected ? (
        <HashRouter>
          <AdminShell>
            <AppRouter />
          </AdminShell>
        </HashRouter>
      ) : (
        <ConnectScreen />
      )}
      <Toaster />
    </>
  );
}
